import ApiProtectedRequest from "utils/apiProtectedClient";

const EP_BASE = "/api";

// ── Crisis Plan (singleton per client) ─────────────────────────────────────

export async function getCrisisPlan(clientId: number | null) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clients/${clientId}/crisis-plan`);
}

export async function createCrisisPlan(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.post(`${EP_BASE}/clients/${clientId}/crisis-plan`, payload);
}

export async function updateCrisisPlan(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/clients/${clientId}/crisis-plan`, payload);
}

// ── Clinical Approach (multi-entry per client) ─────────────────────────────

export async function getClinicalApproach(clientId: number | null) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clients/${clientId}/clinical-approach`);
}

export async function createClinicalApproach(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.post(`${EP_BASE}/clients/${clientId}/clinical-approach`, payload);
}

export async function updateClinicalApproach(id: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/clinical-approach/${id}`, payload);
}

// ── Caregiver Involvement (multi-entry per client) ─────────────────────────

export async function getCaregiverInvolvement(clientId: number | null) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clients/${clientId}/caregiver-involvement`);
}

export async function createCaregiverInvolvement(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.post(`${EP_BASE}/clients/${clientId}/caregiver-involvement`, payload);
}

export async function updateCaregiverInvolvement(id: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/caregiver-involvement/${id}`, payload);
}

// ── Current Communication (singleton per client) ───────────────────────────

export async function getCurrentCommunication(clientId: number | null) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clients/${clientId}/current-communication`);
}

export async function createCurrentCommunication(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.post(`${EP_BASE}/clients/${clientId}/current-communication`, payload);
}

export async function updateCurrentCommunication(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/clients/${clientId}/current-communication`, payload);
}

// ── Telehealth Prerequisites (singleton per client) ────────────────────────

export async function getTelehealthPrerequisites(clientId: number | null) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clients/${clientId}/telehealth-prerequisites`);
}

export async function createTelehealthPrerequisites(
  clientId: number,
  payload: Record<string, unknown>
) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.post(`${EP_BASE}/clients/${clientId}/telehealth-prerequisites`, payload);
}

export async function updateTelehealthPrerequisites(
  clientId: number,
  payload: Record<string, unknown>
) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/clients/${clientId}/telehealth-prerequisites`, payload);
}

// ── Transition & Discharge Planning (multi-entry per client) ───────────────

export async function getDischargePlanning(clientId: number | null) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clients/${clientId}/transition-discharge-planning`);
}

export async function createDischargePlanning(clientId: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.post(
    `${EP_BASE}/clients/${clientId}/transition-discharge-planning`,
    payload
  );
}

export async function updateDischargePlanning(id: number, payload: Record<string, unknown>) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/transition-discharge-planning/${id}`, payload);
}

// ── Clinical Program Targets (promoted target queue) ───────────────────────

export async function getClinicalProgramTargets(clientId: number) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.get(`${EP_BASE}/clinical-program/${clientId}/targets`);
}

export async function saveClinicalProgramTargets(
  clientId: number,
  payload: { target_ids: number[] }
) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.put(`${EP_BASE}/clinical-program/${clientId}/targets`, payload);
}

export async function resetClinicalProgramTargets(clientId: number) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();
  return await Request.delete(`${EP_BASE}/clinical-program/${clientId}/targets`);
}
